// utils
import React from "react";
import { Link, useMatch } from "react-router-dom";
import { Container, Row, Col } from "react-bootstrap";


// custom utils
import { getCurrentLanguage, getUrlPrefix, LANGUAGES } from "../../../../../utils/langUtils";
import { setImage } from "../../../components/setImage";

// translations
import translation_cs from "./lang/cs.json";
import translation_en from "./lang/en.json";
import translation_de from "./lang/de.json";

// files

// components
import BtnBgLemonLearnMore from "../../../../../components/btn/btn-bg-lemon-learn-more";

/**
 * BlogLatest section
 * displays one article with image and corresponding text on BLOG page
 * @returns HTML code for BlogLatest section used on BLOG 
 */
export default function BlogLatest(props: {data:any}) {

    const match = useMatch("/:lang/*");
    let lang = (match && match.params.lang) ? match.params.lang : "";
    
    let translation = translation_cs;
    let language = getCurrentLanguage(lang);
    
    switch (language) {
        case LANGUAGES.Czech:
            translation = translation_cs;
            break;
        case LANGUAGES.English:
            translation = translation_en;
            break;
        case LANGUAGES.German:
            translation = translation_de;
            break;
    }

    return (
        <>
            <div>
                <div className="blog-latest-section navbar-size-compensation">
                    <div className="pt-3 pt-lg-5 pb-3 pb-lg-5">
                        <Container>
                            <Row>
                                <Col xs={12} sm= {12}>
                                    <ul className="blog-latest-categories paragraph-small mb-0 ps-0">
                                        { props.data.tags.slice(0, 1).map((tag:any) => (<li><Link to={ getUrlPrefix(language) + "blog/tag/" + tag }>{ tag }</Link></li>)) }
                                        { props.data.tags.slice(1).map((tag:any) => (<li> ⋅ <Link to={ getUrlPrefix(language) + "blog/tag/" + tag }>{ tag }</Link></li>)) }
                                    </ul>                           
                                </Col>                                    
                            </Row>
                            <Row>
                                <Col xs={12} sm={12}>
                                    <div>
                                        <Link className="font-divelit-lemon blog-latest-header" to={getUrlPrefix(language) + "blog/article/" + props.data.url_name}>
                                            <h2 className="pt-3 pb-2">{ props.data.title }</h2>
                                        </Link>
                                    </div>                                        
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={12}>
                                    <div className="d-flex flex-row">
                                        <img src={setImage(props.data.author_image)} className="blog-latest-author-profile-img me-3 me-md-4" alt={translation.alt.profile_image}/>
                                        <p className="paragraph-small font-white align-self-center mb-0">{ props.data.author }&nbsp;⋅&nbsp;{ props.data.time_to_read }&nbsp;min</p>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="mt-5">
                                <Col xs={12} sm={12} lg={7} xl={8}>
                                    <div className="h-100">
                                        <Link to={getUrlPrefix(language) + "blog/article/" + props.data.url_name}>
                                            <div className="blog-older-img-thumbnail blog-latest-img-border">
                                                <div className="d-flex flex-column h-100">
                                                    <p className="paragraph-medium blog-latest-img-btn align-self-center mt-auto mb-auto">{translation.blog.read_more}<img className="button-arrow"></img></p>
                                                </div>
                                                <img src={setImage(props.data.main_image)} className="blog-latest-img blog-latest-img-border" alt={translation.alt.article_image}/>
                                            </div>
                                        </Link>
                                    </div>
                                </Col>
                                <Col xs={12} sm={12} lg={5} xl={4} className="mt-3 mt-lg-0 ps-3 ps-lg-5">
                                    <p className="paragraph-medium font-white">{ props.data.summary.substring(0,375) }...</p>
                                    <div className="mt-4 mb-0">
                                        <BtnBgLemonLearnMore target={"blog/article/" + props.data.url_name}></BtnBgLemonLearnMore>
                                    </div>
                                </Col>
                            </Row>
                        </Container>  
                    </div>
                </div>
            </div>
        </>
    );
}
